"use client";

import { I18nProvider } from "react-aria-components";

/**
 * Sets the React Aria locale to Chilean Spanish so every HeroUI overlay built on
 * React Aria (DatePicker/Calendar month + weekday names, DateField segment
 * order DD-MM-YYYY, number/date formatting) renders in es-CL. Without this,
 * React Aria falls back to en-US and the calendar shows English.
 */
export default function Providers({ children }: { children: React.ReactNode }) {
  return <I18nProvider locale="es-CL">{children}</I18nProvider>;
}
